/**
 * Converts an Apollo 2.x IntrospectionFragmentMatcher-style introspection result
 * into the Apollo Client 3.x `possibleTypes` map format.
 *
 * Input format:  { __schema: { types: [{ kind, name, possibleTypes: [{ name }] }] } }
 * Output format: { SuperTypeName: ["SubType1", "SubType2"] }
 */
export function introspectionToPossibleTypes(introspectionData: Record<string, any>): Record<string, string[]> {
    const possibleTypes: Record<string, string[]> = {};

    if (!introspectionData?.__schema?.types) {
        return possibleTypes;
    }

    for (const type of introspectionData.__schema.types) {
        if (type.possibleTypes) {
            possibleTypes[type.name] = type.possibleTypes.map((t: any) => t.name);
        }
    }

    return possibleTypes;
}
